export default __webpack_public_path__ + "static/media/dark-active-notification.cae0b326.svg";